import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ui-renta-not-found',
  templateUrl: 'not-found.component.html',
  styleUrl: 'not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIcon,
    RouterLink,
    TranslatePipe,
  ],
})
export class NotFoundComponent {
}
